var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6Month(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#E365B1",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E365B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 11.5C25.7722 11.5 27.6578 11.5 28.8294 12.7448C30.001 13.9896 30.001 15.9931 30.001 20C30.001 24.0069 30.001 26.0104 28.8294 27.2552C27.6578 28.5 25.7722 28.5 22.001 28.5L18.001 28.5C14.2297 28.5 12.3441 28.5 11.1725 27.2552C10.001 26.0104 10.001 24.0069 10.001 20C10.001 15.9931 10.001 13.9896 11.1726 12.7448C12.3441 11.5 14.2297 11.5 18.001 11.5L22.001 11.5Z",
    stroke: "#E365B1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.849 24.608C13.133 24.608 11.885 23.408 11.885 21.932C11.885 20.9 12.257 20.252 12.953 19.412L15.401 16.388H16.781L14.393 19.364C14.633 19.28 14.873 19.232 15.089 19.232C16.673 19.232 17.825 20.3 17.825 21.872C17.825 23.408 16.589 24.608 14.849 24.608ZM14.861 23.588C15.821 23.588 16.565 22.916 16.565 21.908C16.565 20.84 15.821 20.192 14.861 20.192C13.913 20.192 13.157 20.768 13.157 21.896C13.157 22.916 13.913 23.588 14.861 23.588ZM20.0161 24.5H18.8041V18.14H19.9321V19.196C20.3641 18.464 21.0481 18.02 21.9241 18.02C22.8601 18.02 23.5681 18.5 23.8561 19.34C24.3001 18.524 25.0321 18.02 26.0041 18.02C27.3121 18.02 28.1521 18.872 28.1521 20.384V24.5H26.9401V20.768C26.9401 19.712 26.4721 19.088 25.5841 19.088C24.7561 19.088 24.0841 19.784 24.0841 20.852V24.5H22.8721V20.768C22.8721 19.712 22.4041 19.088 21.5161 19.088C20.6761 19.088 20.0161 19.784 20.0161 20.852V24.5Z",
    fill: "#E365B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Month);
export default __webpack_public_path__ + "static/media/6month.be71a0d1c6f2fbf7cb0b913f7e6652e4.svg";
export { ForwardRef as ReactComponent };